import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { CONSTANTS } from "@theatticusapp/atticus-shared-components";
import Page from "../../components/Page";
import { ATTICUS_PAGE_PREFIX, SCREEN_PATHS } from "../../constants";
import { getQueryStringParams } from "@theatticusapp/atticus-shared-components";

// documentation: https://github.com/TheAtticusApp/atticus-app/wiki/Maintenance-mode
export const MaintenanceView = (): JSX.Element => {
  // accept code param to send to config
  const params = getQueryStringParams();
  const code = params?.code || undefined;
  if (code) {
    if (code === "delete") {
      window.localStorage.removeItem(CONSTANTS.STORAGE_KEYS.BYPASS);
    } else {
      window.localStorage.setItem(CONSTANTS.STORAGE_KEYS.BYPASS, code);
    }
  }

  return (
    <Page title={`${ATTICUS_PAGE_PREFIX} - Maintenance Mode`}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Typography align="center" color="textPrimary" variant="h1">
            Atticus is currently under maintenance.
          </Typography>
          <br />
          <Typography align="center" color="textPrimary" variant="subtitle2">
            Maintenance is usually completed in an hour or less. <br />
            Please come back later and{" "}
            <a href={SCREEN_PATHS.auth}>try signing in</a>.
          </Typography>
        </Container>
      </Box>
    </Page>
  );
};
